import { removeLast } from "@matheuscaetano/helprs";

/* eslint-disable import/no-anonymous-default-export */
export default {
  WEEK_DAYS_MAP: {
    0: { name: 'Domingo', fullName: 'Domingo', shortName: 'Dom' },
    1: { name: 'Segunda', fullName: 'Segunda-Feira', shortName: 'Seg' },
    2: { name: 'Terça', fullName: 'Terça-Feira', shortName: 'Ter' },
    3: { name: 'Quarta', fullName: 'Quarta-Feira', shortName: 'Qua' },
    4: { name: 'Quinta', fullName: 'Quinta-Feira', shortName: 'Qui' },
    5: { name: 'Sexta', fullName: 'Sexta-Feira', shortName: 'Sex' },
    6: { name: 'Sábado', fullName: 'Sábado', shortName: 'Sab' },
  } as { [key: number | string]: { name: string; fullName: string; shortName: string } },

  formatStartEndTime(start: string, end: string) {
    return `${removeLast(start, { amount: 3 })}-${removeLast(end, { amount: 3 })}`;
  },

  getAge (dateString: string) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
      {
          age--;
      }
      return age;
  },

  weekDay(dateString?: string) {
    if (! dateString) return '';
    const days = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];
    const date = new Date(dateString);
    return days[date.getDay()];
  },

  currentYear() {
    const date = new Date();
    return date.getFullYear();
  },

  minusOneDay(dateString: string) {
    const date = new Date(dateString);
    date.setDate(date.getDate() - 1);
    return date.toISOString().split('T')[0];
  },
}